import { useTranslation } from 'react-i18next';
import styles from './ContactForm.module.css';
import { useContext, useState } from 'react';
import { UserContext } from 'context/userContext';
import { useForm } from 'react-hook-form';
import { TWO_WORDS_REGEX, VALIDATION_EMAIL_REGEX } from 'config/constants';
import { contact } from 'services/api/miscellaneousService';
import { ContactFormData } from 'types/ContactFormData';
import { InfoModalWrapper } from 'components/modal-content/InfoModalWrapper/InfoModalWrapper';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import ReactModal from 'react-modal';

export const ContactForm = () => {
  const { t } = useTranslation();
  const { loggedUser } = useContext(UserContext);
  const [showModal, setShowModal] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<ContactFormData>();

  const handleFormSubmit = async (data: ContactFormData) => {
    await contact(data);
    reset();
    setShowModal(true);
  };

  return (
    <>
      <div className={styles.wrapper}>
        <span className={styles.contactTitle}>{t('contact_label')}</span>
        <div className={styles.formWrapper}>
          <div>
            <div className={styles.infoMsg}>
              <ThemeIcon icon="info-full" alt="Info" variant="inline" />
              {t('contact_info_message')}
            </div>
          </div>
          <form
            className={styles.form}
            onSubmit={handleSubmit(handleFormSubmit)}
          >
            <div className={styles.formField}>
              <label>{t('username')}</label>
              <input
                type="text"
                placeholder={t('username')}
                value={loggedUser?.username ?? undefined}
                {...register('username')}
              />
            </div>
            <div className={styles.formField}>
              <label>{t('your_email_address_label')} *</label>
              <input
                type="text"
                placeholder={t('your_email_address_label')}
                {...register('email', {
                  required: true,
                  pattern: VALIDATION_EMAIL_REGEX,
                })}
              />
              {errors.email && (
                <ThemeIcon
                  icon="validation-error"
                  alt=""
                  variant="inline"
                  className={styles.error}
                />
              )}
            </div>
            <div className={styles.formField}>
              <label>{t('subject_problem_label')} *</label>
              <input
                type="text"
                placeholder={t('subject_problem_label')}
                {...register('subject', { required: true })}
              />
              {errors.subject && (
                <ThemeIcon
                  icon="validation-error"
                  alt=""
                  variant="inline"
                  className={styles.error}
                />
              )}
            </div>
            <div className={styles.formField}>
              <label>{t('message_label')} *</label>
              <textarea
                placeholder={t('message_label')}
                {...register('content', {
                  required: true,
                  minLength: 3,
                  pattern: TWO_WORDS_REGEX,
                })}
              />
              {errors.content && (
                <ThemeIcon
                  icon="validation-error"
                  alt=""
                  variant="inline"
                  className={styles.error}
                />
              )}
            </div>
            <div className={styles.asteriskExplanation}>
              {t('asterisk_explanation')}
            </div>
            <button>{t('send_label')}</button>
          </form>
        </div>
      </div>
      <ReactModal isOpen={showModal}>
        <InfoModalWrapper onClose={() => setShowModal(false)}>
          <div className={styles.infoModal}>
            <ThemeIcon
              icon="success-checkmark"
              alt="Success"
              variant="inline"
            />
            {t('contact_success_message')}
          </div>
        </InfoModalWrapper>
      </ReactModal>
    </>
  );
};
